import { get } from 'lodash';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';

import MyOfferLayout from 'components/MyOffers';
import messages from 'containers/EpargnDetailsPage/MyOffers/messages';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { translate } from 'helpers/intl';
import { MRH_QUOTE_LINK } from 'constants/externalLinks';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const MyOffers = (props: { intl: IntlShape }) => {
  const language = useSelector(getLocaleSelector);

  return (
    <MyOfferLayout
      category={EVENT_CATEGORIES.EPARGN_DETAILS}
      gaLabel="Mes contrats_Faire un devis"
      title={translate(get(messages, 'title'), props)}
      subTitle={translate(get(messages, 'subTitle'), props)}
      body={translate(get(messages, 'body'), props)}
      actionPath={MRH_QUOTE_LINK[language]}
      actionLabel={translate(get(messages, 'action'), props)}
      image="house"
    />
  );
};

export default injectIntl(MyOffers);
